module.exports = __webpack_public_path__ + "img/-LV55pr3N321IhjDo1C2.1a186ced.jpg";